import * as React from "react";
import { useState, useEffect } from "react";
import { Line } from "@ant-design/plots";
import { getJSONData } from "../utils";

const LineChart = () => {
  const [data, setData] = useState([]);
  const [annotations, setAnnotations] = useState([]);

  const baseAnnotation = {
    type: "dataMarker",
    position: ["2018-09-23", 157040],
    text: {
      content: "Stuff Happened",
      style: {
        textAlign: "center",
        fill: "gray",
      },
    },
    line: {
      length: 150,
      style: {
        stroke: "lightgray",
      },
    },
    point: {
      size: 5,
      style: {
        fill: "lightgray",
        stroke: "lightgray",
      },
    },
    autoAdjust: true,
  };

  useEffect(() => {
    asyncFetch();
  }, []);
  const asyncFetch = () => {
    fetch(`${process.env.GATSBY_PATH_PREFIX}/data/freqs.json`)
      .then((response) => response.json())
      .then((json) => {
        setData(json);
      })
      .catch((error) => {
        console.log("fetch data failed", error);
      });

    const getEvents = getJSONData(
      `${process.env.GATSBY_PATH_PREFIX}/data/events.json`
    );
    getEvents.then((data) => {
      const annoHolder = [];
      data.forEach((el) => {
        const anno = JSON.parse(JSON.stringify(baseAnnotation));
        //Object.assign({}, baseAnnotation);
        anno.position = [el.date, el.freq];
        anno.text.content = el.event;
        anno.line.length = el.line;
        anno.text.style.textAlign = el.align;
        annoHolder.push(anno);
      });
      // console.log(annoHolder);
      setAnnotations(annoHolder);
    });
  };

  const config = {
    data,
    xField: "fulldate",
    yField: "tweets",
    seriesField: "group",
    yAxis: {
      label: {
        formatter: (v) => `${(v / 10e3).toFixed(1)} K`,
      },
    },
    annotations: annotations,
    legend: {
      itemValue: {
        formatter: (v) => {
          if (v === "original") {
            return "tweets";
          } else return "";
        },
      },
      itemName: {
        formatter: (v) => {
          if (v === "original") {
            return "Original";
          } else if (v === "political") {
            return "Political tweets";
          } else {
            return "All tweets and retweets";
          }
        },
      },
    },
    // point: {
    //   shape: "circle",
    // },
    smooth: true,
    animation: {
      appear: {
        duration: 8000,
      },
    },
  };

  return (
    <div className="">
      <Line {...config} />
    </div>
  );
};

export default LineChart;
